import { useEffect, useRef } from 'react';

import { useFormContext } from 'react-hook-form';

import { CreateAccountFormValues } from './createAccountValidationSchema';
import {
  BUSINESS_ONLY_FIELD_KEYS,
  emptyBankAccountRow,
  emptyDependentRow,
  INDIVIDUAL_ONLY_FIELD_KEYS,
} from './entityFormDefaults';
import { useCreateAccountFormVisibility } from './useCreateAccountFormVisibility';

/**
 * Clears business-only or individual-only fields when entity_type crosses
 * the individual/business boundary (mirrors refactor entity change behavior).
 */
export function useCreateAccountEntityTypeReset() {
  const { setValue } = useFormContext<CreateAccountFormValues>();
  const { isIndividual, entityType } = useCreateAccountFormVisibility();
  const previousIsIndividual = useRef<boolean | null>(null);

  useEffect(() => {
    if (!entityType) {
      previousIsIndividual.current = null;
      return;
    }

    if (previousIsIndividual.current === null) {
      previousIsIndividual.current = isIndividual;
      return;
    }

    if (previousIsIndividual.current === isIndividual) {
      return;
    }

    if (isIndividual) {
      BUSINESS_ONLY_FIELD_KEYS.forEach((key) => {
        setValue(key, key === 'encryptedCoEin' ? '' : '');
      });
      setValue('bankAccounts', [{ ...emptyBankAccountRow }]);
    } else {
      INDIVIDUAL_ONLY_FIELD_KEYS.forEach((key) => {
        setValue(key, '');
      });
      setValue('dependents', [{ ...emptyDependentRow }]);
    }

    previousIsIndividual.current = isIndividual;
  }, [entityType, isIndividual, setValue]);
}
